// ============================================================
//  PRODUCTOS DE AFILIADO - Mercado Libre, Amazon, Hotmart
//  
//  ¿Cómo agregar un producto?
//
//  1. MERCADO LIBRE:
//     - Ve a afiliados.mercadolibre.cl
//     - Regístrate y obtén tu ID de afiliado
//     - Busca el producto y copia el link con tu ID
//     - Agrega el producto en la sección MERCADOLIBRE abajo
//
//  2. AMAZON:
//     - Ve a afiliados.amazon.es o affiliate-program.amazon.com
//     - Regístrate en Amazon Associates
//     - Usa el SiteStripe para generar tu link de afiliado
//     - Agrega el producto en la sección AMAZON abajo
//
//  3. HOTMART:
//     - Ve a hotmart.com > Mercado de Afiliados
//     - Elige el producto digital y copia tu link
//     - Agrega el producto en la sección HOTMART abajo
//
//  CAMPOS OBLIGATORIOS:
//  - id: número único (continúa desde el último)
//  - name: nombre del producto
//  - price: precio en CLP (solo número, sin puntos)
//  - image: URL de la imagen del producto
//  - affiliateLink: tu link de afiliado (¡IMPORTANTE! es el que genera tu comisión)
//  - platform: 'mercadolibre' | 'amazon' | 'hotmart'
//  - category: categoría donde aparecerá
//
//  CAMPOS OPCIONALES:
//  - originalPrice: precio tachado
//  - badge / badgeColor: etiqueta de oferta
//  - description: descripción corta
//  - commission: tu comisión (solo referencia, no se muestra al cliente)
// ============================================================

export const AFFILIATE_PRODUCTS = [

  // ── MERCADO LIBRE ────────────────────────────────────────
  // 👇 Reemplaza affiliateLink con tu link real de afiliado ML
  {
    id: 'ml-1',
    platform: 'mercadolibre',
    category: 'tecnologia',
    name: 'Nintendo Switch Oled (edición Blanca) + Mario Wonder Bundle',
    price: 19990,
    originalPrice: 29990,
    rating: 4.6,
    reviews: 342,
    badge: 'MercadoLibre',
    badgeColor: '#FFE600',
    badgeTextColor: '#333',
    description: 'Nintendo Switch Oled (edición Blanca) + Mario Wonder Bundle',
    // 👇 Cambia esta URL por tu link de afiliado de Mercado Libre
    affiliateLink: 'https://meli.la/1sxyrDq',
    image: '/images/Imagen43.png',
    
  },
  {
    id: 'ml-2',
    platform: 'mercadolibre',
    category: 'hogar',
    name: 'Aspiradora Inalámbrica Osoji D300 Plus 650w Color Blanco',
    price: 249990,
    originalPrice: 479990,
    rating: 4.8,
    reviews: 134,
    badge: 'MercadoLibre',
    badgeColor: '#FFE600',
    badgeTextColor: '#333',
    description: 'Aspiradora inalámbrica Osoji D300 Plus 650w Color Blanco',
    // 👇 Cambia esta URL por tu link de afiliado de Mercado Libre
    affiliateLink: 'https://meli.la/2bEwc25',
    image: '/images/Imagen44.png',
    
  },
  {
    id: 'ml-3',
    platform: 'mercadolibre',
    category: 'mascotas',
    name: 'Batería Externa Power Bank 20000 Mah 22.5w Power Delivery Master-G Color Azul',
    price: 19990,
    originalPrice: 34990,
    rating: 4.9,
    reviews: 9688,
    badge: 'MercadoLibre',
    badgeColor: '#FFE600',
    badgeTextColor: '#333',
    description: 'Batería externa Power Bank 20000 Mah 22.5w Power Delivery Master-G Color Azul',
    affiliateLink: 'https://meli.la/1jgv87n',
    image: '/images/Imagen45.png',
    commission: '5%',
  },

  // ── AMAZON ───────────────────────────────────────────────
  // 👇 Reemplaza affiliateLink con tu link real de Amazon Associates
  {
    id: 'amz-1',
    platform: 'amazon',
    category: 'libro',
    name: '11+ GL Maths Complete Revision and Practice - Ages 10-11 (with Online Edition) (CGP GL 11+ Ages 10-11)',
    price: 17.99,
    originalPrice: null,
    rating: 4.9,
    reviews: 2341,
    badge: 'Amazon',
    badgeColor: '#FF9900',
    badgeTextColor: '#fff',
    description: '11+ GL Maths Complete Revision and Practice - Ages 10-11 (with Online Edition) (CGP GL 11+ Ages 10-11). A comprehensive revision guide for 11+ GL Maths, including practice questions and an online edition.',
    // 👇 Cambia esta URL por tu link de Amazon Associates
    affiliateLink: 'https://amzn.to/43qUk8u',
    image: '/images/Imagen48.png',
   
  },
  {
    id: 'amz-2',
    platform: 'amazon',
    category: 'hogar',
    name: 'Basics Paquete de 6 Bolsas de vacío para Almacenamiento de Ropa, Incluyen Bomba Manual de vacío, con Cremallera, tamaño Extragrande,Jumbo, Transparente',
    price: 24.72,
    originalPrice:null,
    rating: 4.5,
    reviews: 134658,
    badge: 'Amazon',
    badgeColor: '#FF9900',
    badgeTextColor: '#fff',
    description: 'Paquete de 6 bolsas de vacío para almacenamiento de ropa, incluyen bomba manual de vacío, con cremallera, tamaño extragrande, jumbo, transparente.',
    affiliateLink: 'https://amzn.to/43xgLsF',
    image: '/images/Imagen47.png',
   
  },

  // ── HOTMART ──────────────────────────────────────────────
  // 👇 Reemplaza affiliateLink con tu link real de Hotmart
  {
    id: 'hot-1',
    platform: 'hotmart',
    category: 'Salud y Bienestar',
    name: '120 Recetas para bajar de peso y desinflamar + Plan de alimentación',
    price: 14.99,
    originalPrice: null,
    rating: 4.9,
    reviews: 1203,
    badge: 'Hotmart',
    badgeColor: '#F04E23',
    badgeTextColor: '#fff',
    description: '120 recetas para bajar de peso y desinflamar + Plan de alimentación. +60 horas de video, acceso de por vida.',
    // 👇 Cambia esta URL por tu link de afiliado de Hotmart
    affiliateLink: 'https://go.hotmart.com/B106276634I?dp=1',
    image: '/images/salud.png',
    isDigital: true, // Producto digital
  },
  {
    id: 'hot-2',
    platform: 'hotmart',
    category: 'ofertas',
    name: 'Gelatinas Novedosas como Negocio Rentable',
    price: 114.72,
    originalPrice: null,
    rating: 4.8,
    reviews: 456,
    badge: 'Hotmart',
    badgeColor: '#F04E23',
    badgeTextColor: '#fff',
    description: 'Curso Gelatinas Novedosas como Negocio Rentable. Aprende a hacer gelatinas creativas y emprende tu propio negocio.',
    affiliateLink: 'https://go.hotmart.com/B106276634I?dp=1',
    image: '/images/Imagen46.png',
    isDigital: true,
  },
];

// Filtra por plataforma
export const getByPlatform = (platform) =>
  AFFILIATE_PRODUCTS.filter(p => p.platform === platform);

// Filtra por categoría
export const getByCategory = (category) =>
  AFFILIATE_PRODUCTS.filter(p => p.category === category);

// Íconos y colores de cada plataforma
export const PLATFORM_INFO = {
  mercadolibre: {
    label: 'Mercado Libre',
    icon: '🛒',
    color: '#FFE600',
    textColor: '#333',
    bgColor: '#FFFDE7',
  },
  amazon: {
    label: 'Amazon',
    icon: '📦',
    color: '#FF9900',
    textColor: '#fff',
    bgColor: '#FFF3E0',
  },
  hotmart: {
    label: 'Hotmart',
    icon: '🔥',
    color: '#F04E23',
    textColor: '#fff',
    bgColor: '#FBE9E7',
  },
};
